import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Mail, Loader2 } from 'lucide-react';
import { LeadReportRecipients } from './LeadReportRecipients';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Monthly email status + manual send for a completed month.
export const LeadReportEmail = ({ token, month, isCurrent }) => {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);
  const auth = { headers: { Authorization: `Bearer ${token}` } };
  const load = () => axios.get(`${API_URL}/admin/lead-report/email-status`, auth).then((r) => setStatus(r.data)).catch(() => {});
  useEffect(() => { load(); }, [token]); // eslint-disable-line react-hooks/exhaustive-deps
  const sent = status?.history?.find((h) => h.month === month && h.sent);
  const send = async () => {
    if (!window.confirm(`${sent ? 'Re-send' : 'Send'} the ${month} lead report to ${(status?.recipients || []).join(', ')}?`)) return;
    setBusy(true);
    try {
      const r = await axios.post(`${API_URL}/admin/lead-report/send-email`, null, { ...auth, params: { month } });
      if (r.data.sent) toast.success(`Report emailed to ${r.data.to}`); else toast.error(r.data.skipped || 'Email could not be sent');
      load();
    } catch (e) { toast.error(e.response?.data?.detail || 'Email could not be sent'); } finally { setBusy(false); }
  };
  if (!status) return null;
  return (
    <div className="flex flex-wrap items-center gap-3 text-xs text-neutral-500 bg-neutral-50 border border-neutral-200 rounded-lg px-3 py-2" data-testid="lead-report-email">
      <Mail className="w-4 h-4 text-neutral-400" />
      <span>Automatic email: {status.schedule} to <strong className="text-neutral-700" data-testid="lead-report-recipient-list">{status.recipients?.length ? status.recipients.join(', ') : 'no recipients set'}</strong>.</span>
      <LeadReportRecipients />
      <span data-testid="lead-report-email-state">{isCurrent ? 'This month will be sent after it ends.' : sent ? `Sent ${new Date(sent.sent_at).toLocaleString('en-US', { timeZone: 'America/New_York', dateStyle: 'medium', timeStyle: 'short' })} ET.` : 'Not emailed yet.'}</span>
      {!isCurrent && <button type="button" onClick={send} disabled={busy} className="ml-auto inline-flex items-center gap-1 underline text-neutral-700 hover:text-neutral-900 disabled:opacity-50" data-testid="lead-report-send-email">{busy && <Loader2 className="w-3 h-3 animate-spin" />}{sent ? 'Re-send this month' : 'Send this month now'}</button>}
    </div>
  );
};
